module.exports = __webpack_public_path__ + "4cbdf024e1771f85009d0b4fac1dabfa.png";